import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button, { IButtonProps } from '../Button';

// Types
import { IStore } from '../../store/Store';

// Component
interface IProps extends IButtonProps {
    store?: IStore;

    routeName: string;
    routeParams?: object;
    routeOptions?: object;
}

function LinkButton({ store, routeName, routeParams = {}, routeOptions = {}, onClick, ...props }: IProps) {
    return (
        <Button
            {...props}
            onClick={(e: React.MouseEvent<HTMLAnchorElement|HTMLButtonElement>) => {
                if (onClick) {
                    // tslint:disable-next-line
                    (onClick as any)(e);
                }
                store!.routerStore.navigate(routeName, routeParams, routeOptions);
            }}
        />
    );
}

export default inject('store')(observer(LinkButton));


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LinkButton/LinkButton.tsx